module.exports = __webpack_public_path__ + "858cda3799c7604db64e2fce61cef419.svg";